<app-header [forceLightBackground]="true"></app-header>
<div class="provider-manage-contribution">
  <div class="provider-manage-contribution--layout">
    <app-provider-sidebar class="provider-manage-contribution--sidebar"></app-provider-sidebar>
    <div class="provider-manage-contribution--content">
      <app-page-header></app-page-header>
      <app-manage-contribution 
        actionContext="provider"
        (reloadData)="reloadMyAssets()"
        (filterChange)="onFilterChange($event)"
        (requestData)="onRequestData($event)"
      ></app-manage-contribution>
    </div>
  </div>
</div>
